// utils/formatGameDate.js
export function formatGameDate(games) {
    const dateStr = games?.[0]?.date; // "2025-10-01"
    if (!dateStr) return null;
    const [, month, day] = dateStr.split("-");
    return `${parseInt(month, 10)}-${parseInt(day, 10)}`; // "10-1"
}